export default __webpack_public_path__ + "static/media/forbes.005115b4.png";